import Vue from 'vue'
import Router from 'vue-router'
import SetMap from '@/components/SetMap'
import Login from '@/components/Login/Login'
import HomeIndex from '@/components/Home/Index'
import HomeCenter from '@/components/Home/Center'
import CabinetCabinetList from '@/components/Cabinet/CabinetList'
import CabinetCabinetEdit from '@/components/Cabinet/CabinetEdit'
import Company from '@/components/Company/CompanyList'
import CompanyEdit from '@/components/Company/CompanyEdit'
import AlarmList from '@/components/Alarm/AlarmList'
import AlarmHistoryList from '@/components/Alarm/AlarmHistoryList'
import CabinetModelList from '@/components/CabinetModel/CabinetModelList'
import CabinetModelEdit from '@/components/CabinetModel/CabinetModelEdit'
import FeeConfigList from '@/components/FeeConfig/FeeConfigList'
import FeeConfigEdit from '@/components/FeeConfig/FeeConfigEdit'
import NavList from '@/components/Setting/NavList'
import NavEdit from '@/components/Setting/NavEdit'
import DailyList from '@/components/Report/DailyList'
import MonthlyList from '@/components/Report/MonthlyList'
import MemberReg from '@/components/Report/MemberReg'
import OrderShow from '@/components/Order/OrderShow'
import OrderEdit from '@/components/Order/OrderEdit'
import OrderList from '@/components/Order/OrderList'
import CabinetShow from '@/components/Monitor/CabinetShow'
import CabinetList from '@/components/Monitor/CabinetList'
import ManagerEdit from '@/components/Manager/ManagerEdit'
import ManagerList from '@/components/Manager/ManagerList'
import WorkOrderEdit from '@/components/WorkOrder/WorkOrderEdit'
import WorkOrderHandle from '@/components/WorkOrder/WorkOrderHandle'

import WorkOrderList from '@/components/WorkOrder/WorkOrderList'
import ManagerLog from '@/components/Manager/ManagerLog'
import Password from '@/components/Manager/Password'
import RoleEdit from '@/components/Manager/RoleEdit'
import RoleList from '@/components/Manager/RoleList'
import ReconciliationList from '@/components/Reconciliation/ReconciliationList'
import ReconciliationEdit from '@/components/Reconciliation/ReconciliationEdit'
import VersioningList from '@/components/Versioning/VersioningList'
import DistributeList from '@/components/Versioning/DistributeList'
import VersioningEdit from '@/components/Versioning/VersioningEdit'
import VersioningAdd from '@/components/Versioning/VersioningAdd'
import VersioningLook from '@/components/Versioning/VersioningLook'
import CabinetDetails from '@/components/Monitor/CabinetDetails'
import Bms from '@/components/Monitor/Bms'
import Pcs from '@/components/Monitor/Pcs'
import Cell from '@/components/Monitor/Cell'
import Distribute from '@/components/Monitor/Distribute'

import DayaheadPlan from '@/components/VirtualPowerPlant/DayaheadPlan/DayaheadPlan'
import DayaheadPlanShow from '@/components/VirtualPowerPlant/DayaheadPlan/DayaheadPlanShow'
import Invitation from '@/components/VirtualPowerPlant/Invitation/Invitation'
import InvitationShow from '@/components/VirtualPowerPlant/Invitation/InvitationShow'
import Calculation from '@/components/Calculation/Calculation'
import CalculationEdit from '@/components/Calculation/CalculationEdit'
import CalculationEditTime from '@/components/Calculation/CalculationEditTime'
import MoreParameters from '@/components/MoreParameters'
import CalculationMoreParameters from '@/components/Calculation/CalculationMoreParameters'
import Voltage from '@/components/Monitor/Voltage'
import Regulation from '@/components/Regulation/Regulation'
import RegulationEdit from '@/components/Regulation/RegulationEdit'
import PlanEdit from '@/components/Regulation/PlanEdit'
import PlanEdits from '@/components/Regulation/PlanEdits'

import Haiyiconfig from '@/components/HaiYi/HaiYiList'
import HaiyiEdit from '@/components/HaiYi/HaiYiEdit'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: '登录', icon: 'icon-supplier' }
    },
    {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex,
      meta: { title: '首页', icon: 'icon-supplier' }
    },
    {
      path: '/home/center',
      name: 'HomeCenter',
      component: HomeCenter,
      meta: { title: '首页看板', icon: 'icon-supplier' }
    },
    {
      path: '/cabinets/cabinetList',
      name: 'CabinetCabinetList',
      component: CabinetCabinetList,
      meta: { title: '设备管理', icon: 'icon-supplier' }
    },
    {
      path: '/cabinets/cabinetEdit',
      name: 'CabinetCabinetEdit',
      component: CabinetCabinetEdit,
      meta: { title: '设备编辑', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/cabinetDetails',
      name: 'CabinetDetails',
      component: CabinetDetails,
      meta: { title: '设备详情', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/bms',
      name: 'Bms',
      component: Bms,
      meta: { title: 'BMS', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/pcs',
      name: 'Pcs',
      component: Pcs,
      meta: { title: 'PCS', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/cell',
      name: 'Cell',
      component: Cell,
      meta: { title: '电芯', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/distribute',
      name: 'Distribute',
      component: Distribute,
      meta: { title: '参数下发', icon: 'icon-supplier' }
    },
    {
      path: '/company/company',
      name: 'Company',
      component: Company,
      meta: { title: '客户管理', icon: 'icon-supplier' }
    },
    {
      path: '/company/companyEdit',
      name: 'CompanyEdit',
      component: CompanyEdit,
      meta: { title: '客户编辑', icon: 'icon-supplier' }
    },
    {
      path: '/alarm/alarmList',
      name: 'AlarmList',
      component: AlarmList,
      meta: { title: '报警管理', icon: 'icon-supplier' }
    },
    {
      path: '/alarm/alarmHistoryList',
      name: 'AlarmHistoryList',
      component: AlarmHistoryList,
      meta: { title: '报警历史列表', icon: 'icon-supplier' }
    },
    {
      path: '/cabinetModel/cabinetModelList',
      name: 'CabinetModelList',
      component: CabinetModelList,
      meta: { title: '会员管理', icon: 'icon-supplier' }
    },
    {
      path: '/cabinetModel/cabinetModelEdit',
      name: 'CabinetModelEdit',
      component: CabinetModelEdit,
      meta: { title: '会员编辑', icon: 'icon-supplier' }
    },
    {
      path: '/feeConfig/feeConfigList',
      name: 'FeeConfigList',
      component: FeeConfigList,
      meta: { title: '费率管理', icon: 'icon-supplier' }
    },
    {
      path: '/feeConfig/feeConfigEdit',
      name: 'FeeConfigEdit',
      component: FeeConfigEdit,
      meta: { title: '费率编辑', icon: 'icon-supplier' }
    },
    {
      path: '/setting/navList',
      name: 'NavList',
      component: NavList,
      meta: { title: '导航菜单管理', icon: 'icon-supplier' }
    },
    {
      path: '/setting/navEdit',
      name: 'NavEdit',
      component: NavEdit,
      meta: { title: '导航菜单编辑', icon: 'icon-supplier' }
    },
    {
      path: '/report/dailyList',
      name: 'DailyList',
      component: DailyList,
      meta: { title: '日报管理', icon: 'icon-supplier' }
    },
    {
      path: '/report/memberReg',
      name: 'MemberReg',
      component: MemberReg,
      meta: { title: '会员管理', icon: 'icon-supplier' }
    },
    {
      path: '/report/monthlyList',
      name: 'MonthlyList',
      component: MonthlyList,
      meta: { title: '月报管理', icon: 'icon-supplier' }
    },
    {
      path: '/order/orderList',
      name: 'OrderList',
      component: OrderList,
      meta: { title: '订单管理', icon: 'icon-supplier' }
    },
    {
      path: '/order/orderEdit',
      name: 'OrderEdit',
      component: OrderEdit,
      meta: { title: '编辑订单', icon: 'icon-supplier' }
    },
    {
      path: '/order/orderShow',
      name: 'OrderShow',
      component: OrderShow,
      meta: { title: '查看订单', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/cabinetList',
      name: 'CabinetList',
      component: CabinetList,
      meta: { title: '设备监控', icon: 'icon-supplier' }
    },
    {
      path: '/monitor/cabinetShow',
      name: 'CabinetShow',
      component: CabinetShow,
      meta: { title: '设备监控详情', icon: 'icon-supplier' }
    },
    {
      path: '/manager/roleList',
      name: 'RoleList',
      component: RoleList,
      meta: { title: '角色管理', icon: 'icon-supplier' }
    },
    {
      path: '/manager/roleEdit',
      name: 'RoleEdit',
      component: RoleEdit,
      meta: { title: '角色编辑', icon: 'icon-supplier' }
    },
    {
      path: '/manager/password',
      name: 'Password',
      component: Password,
      meta: { title: '修改管理员密码', icon: 'icon-supplier' }
    },
    {
      path: '/manager/managerLog',
      name: 'ManagerLog',
      component: ManagerLog,
      meta: { title: '管理日志', icon: 'icon-supplier' }
    },
    {
      path: '/manager/managerList',
      name: 'ManagerList',
      component: ManagerList,
      meta: { title: '管理员管理', icon: 'icon-supplier' }
    },
    {
      path: '/manager/managerEdit',
      name: 'ManagerEdit',
      component: ManagerEdit,
      meta: { title: '管理员编辑', icon: 'icon-supplier' }
    },
    {
      path: '/workOrder/workOrder',
      name: 'WorkOrderList',
      component: WorkOrderList,
      meta: { title: '工单管理', icon: 'icon-supplier' }
    },
    {
      path: '/workOrder/workOrderEdit',
      name: 'WorkOrderEdit',
      component: WorkOrderEdit,
      meta: { title: '工单编辑', icon: 'icon-supplier' }
    },
    {
      path: '/workOrder/workOrderHandle',
      name: 'WorkOrderHandle',
      component: WorkOrderHandle,
      meta: { title: '工单处理', icon: 'icon-supplier' }
    },
    {
      path: '/reconciliation/reconciliationList',
      name: 'ReconciliationList',
      component: ReconciliationList,
      meta: { title: '对账单管理', icon: 'icon-supplier' }
    },
    {
      path: '/reconciliation/reconciliationEdit',
      name: 'ReconciliationEdit',
      component: ReconciliationEdit,
      meta: { title: '对账单编辑', icon: 'icon-supplier' }
    },
    {
      path: '/versioning/versioningList',
      name: 'VersioningList',
      component: VersioningList,
      meta: { title: '版本管理', icon: 'icon-supplier' }
    },
    {
      path: '/versioning/distributeList',
      name: 'DistributeList',
      component: DistributeList,
      meta: { title: '版本下发列表', icon: 'icon-supplier' }
    },
    {
      path: '/versioning/versioningEdit',
      name: 'VersioningEdit',
      component: VersioningEdit,
      meta: { title: '版本编辑', icon: 'icon-supplier' }
    },
    {
      path: '/versioning/VersioningAdd',
      name: 'VersioningAdd',
      component: VersioningAdd,
      meta: { title: '版本新增', icon: 'icon-supplier' }
    },
    {
      path: '/versioning/VersioningLook',
      name: 'VersioningLook',
      component: VersioningLook,
      meta: { title: '版本查看', icon: 'icon-supplier' }
    },
    {
      path: '/setmap',
      name: 'SetMap',
      component: SetMap,
      meta: { title: '大屏配置', icon: 'icon-supplier' }
    },
    {
      path: '/dayaheadPlan',
      name: 'DayaheadPlan',
      component: DayaheadPlan,
      meta: { title: '日前调度', icon: 'icon-supplier' }
    },
    {
      path: '/dayaheadPlan/dayaheadPlanShow',
      name: 'DayaheadPlanShow',
      component: DayaheadPlanShow,
      meta: { title: '查看详情', icon: 'icon-supplier' }
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: Invitation,
      meta: { title: '邀约', icon: 'icon-supplier' }
    },
    {
      path: '/Invitation/InvitationShow',
      name: 'InvitationShow',
      component: InvitationShow,
      meta: { title: '查看详情', icon: 'icon-supplier' }
    },
    {
      path: '/Calculation/CalculationList',
      name: 'Calculation',
      component: Calculation,
      meta: { title: '测算', icon: 'icon-supplier' }
    },
    {
      path: '/Calculation/CalculationEdit',
      name: 'CalculationEdit',
      component: CalculationEdit,
      meta: { title: '测算编辑', icon: 'icon-supplier' }
    },
    {
      path: '/Calculation/CalculationEditTime',
      name: 'CalculationEditTime',
      component: CalculationEditTime,
      meta: { title: '测算编辑', icon: 'icon-supplier' }
    },
    {
      path: '/CalculationMoreParameters',
      name: 'CalculationMoreParameters',
      component: CalculationMoreParameters,
      meta: { title: '跟多测算配置', icon: 'icon-supplier' }
    },
    {
      path: '/MoreParameters',
      name: 'MoreParameters',
      component: MoreParameters,
      meta: { title: '跟多配置', icon: 'icon-supplier' }
    },
    {
      path: '/Voltage',
      name: 'Voltage',
      component: Voltage,
      meta: { title: '电压图', icon: 'icon-supplier' }
    },
    {
      path: '/regulation/regulation',
      name: 'Regulation',
      component: Regulation,
      meta: { title: '调控', icon: 'icon-supplier' }
    },
    {
      path: '/regulation/regulationEdit',
      name: 'RegulationEdit',
      component: RegulationEdit,
      meta: { title: '调控编辑', icon: 'icon-supplier' }
    },
    {
      path: '/regulation/planEdit',
      name: 'PlanEdit',
      component: PlanEdit,
      meta: { title: '计划编辑', icon: 'icon-supplier' }
    },
    {
      path: '/regulation/planEdits',
      name: 'PlanEdits',
      component: PlanEdits,
      meta: { title: '计划', icon: 'icon-supplier' }
    },
    {
      path: '/setting/haiyiconfig',
      name: 'Haiyiconfig',
      component: Haiyiconfig,
      meta: { title: '海颐配置', icon: 'icon-supplier' }
    },
    {
      path: '/setting/haiyiEdit',
      name: 'HaiyiEdit',
      component: HaiyiEdit,
      meta: { title: '海颐编辑', icon: 'icon-supplier' }
    },
  ]
})
router.beforeEach((to, from, next) => {
  console.log("fx_client_access_token", localStorage.getItem('fx_client_access_token'))
  if (to.path !== '/login') {
    if (!!!localStorage.getItem('fx_client_access_token') || localStorage.getItem('fx_client_access_token') === '') {
      next('/login')
      return;
    }
  }
  next();

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js